var $nKhrS$react = require("react");
var $nKhrS$truvbridge = require("@truv/bridge");


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "TruvBridgeInline", function () { return $9bd66242e1837e9d$export$fa3c7ac81b8ad33d; });
$parcel$export(module.exports, "default", function () { return $9bd66242e1837e9d$export$2e2bcd8739ae039; });


const $9bd66242e1837e9d$var$TruvBridge = ({ isOpened: isOpened, ...currentLastInitData })=>{
    const lastInitData = (0, $nKhrS$react.useRef)(currentLastInitData);
    lastInitData.current = currentLastInitData;
    (0, $nKhrS$react.useEffect)(()=>{
        if (!isOpened) return;
        const { onSuccess: onSuccess, onClose: onClose, onLoad: onLoad, onEvent: onEvent, ...restInitData } = lastInitData.current;
        // We use lastInitData.current in the callbacks to ensure that we have the latest data
        const bridgeInstance = (0, $nKhrS$truvbridge.init)({
            ...restInitData,
            onSuccess (publicToken, metadata) {
                lastInitData.current.onSuccess(publicToken, metadata);
            },
            onClose () {
                lastInitData.current.onClose?.();
            },
            onLoad () {
                lastInitData.current.onLoad?.();
            },
            onEvent (type, payload) {
                lastInitData.current.onEvent?.(type, payload);
            }
        });
        bridgeInstance.open();
        return ()=>{
            bridgeInstance.close();
        };
    }, [
        isOpened
    ]);
    return null;
};
const $9bd66242e1837e9d$export$fa3c7ac81b8ad33d = /*#__PURE__*/ (0, $nKhrS$react.forwardRef)(({ bridgeParams: bridgeParams, isOpened: isOpened, ...divProps }, ref)=>{
    const [isReadyToOpen, setReadyToOpened] = (0, $nKhrS$react.useState)(false);
    const innerRef = (0, $nKhrS$react.useRef)(null);
    (0, $nKhrS$react.useImperativeHandle)(ref, ()=>innerRef.current);
    (0, $nKhrS$react.useEffect)(()=>{
        // We need to wait for the ref to be set before we can open the bridge
        setReadyToOpened(isOpened);
    }, [
        isOpened
    ]);
    return /*#__PURE__*/ (0, ($parcel$interopDefault($nKhrS$react))).createElement("div", {
        ...divProps,
        ref: innerRef
    }, isReadyToOpen && innerRef.current && !!bridgeParams && /*#__PURE__*/ (0, ($parcel$interopDefault($nKhrS$react))).createElement($9bd66242e1837e9d$var$TruvBridge, {
        isOpened: isOpened,
        ...bridgeParams,
        position: {
            type: 'inline',
            container: innerRef.current
        }
    }));
});
var $9bd66242e1837e9d$export$2e2bcd8739ae039 = $9bd66242e1837e9d$var$TruvBridge;


//# sourceMappingURL=index.js.map
